<div class="container">
  <input
    #search
    class="search-text"
    type="text"
    autofocus
    placeholder="{{ 'workorders.search.placeholder' | translate }}"
    [(ngModel)]="searchTerm"
    (keyup)="updateSearchText(search.value)"
  />
  <mat-icon class="search-icon">search</mat-icon>
</div>
